import { motion } from "framer-motion";
import { Mail } from "lucide-react";

export function Maintenance() {
  return (
    <div className="grain min-h-screen bg-cream flex flex-col items-center justify-center px-6 text-center relative overflow-hidden">
      <div className="absolute -right-32 -top-32 w-[28rem] h-[28rem] rounded-full bg-terracotta/15 blur-3xl" />
      <div className="absolute -left-32 -bottom-32 w-[28rem] h-[28rem] rounded-full bg-sage/15 blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative max-w-xl"
      >
        <div className="font-display font-extrabold text-3xl tracking-tightest text-ink mb-10">
          Job<span className="text-terracotta">Propulse</span>
        </div>

        <span className="inline-flex items-center gap-2 font-body text-xs uppercase tracking-[0.25em] text-terracotta mb-7">
          <span className="w-8 h-px bg-terracotta" /> Maintenance en cours
        </span>

        <h1 className="font-display font-extrabold text-5xl md:text-6xl tracking-tightest leading-[0.95] text-ink">
          On revient très vite.
        </h1>

        <p className="mt-6 text-lg text-stone font-body leading-relaxed">
          Notre site fait peau neuve pour mieux t'accompagner dans ton orientation et ta recherche d'alternance. Merci de ta patience — on sera de retour sous peu.
        </p>

        <a
          href="mailto:bonjour@jobpropulse.fr"
          data-testid="maintenance-contact"
          className="inline-flex items-center gap-2 mt-9 rounded-full bg-ink text-cream px-7 py-3.5 font-body font-semibold hover:bg-terracotta transition-colors duration-300"
        >
          <Mail className="w-4 h-4" /> Nous écrire
        </a>
      </motion.div>

      <div className="absolute bottom-8 text-stone/70 font-body text-sm">
        © {new Date().getFullYear()} JobPropulse · Coaching orientation & alternance
      </div>
    </div>
  );
}
